var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible && _vm.event
    ? _c(
        "div",
        {
          staticClass: "timeline-popup",
          style: _vm.popupStyle,
          attrs: { "data-testid": "timeline-popup" },
          on: {
            mouseenter: function ($event) {
              return _vm.$emit("popup-enter")
            },
            mouseleave: function ($event) {
              return _vm.$emit("popup-leave")
            },
          },
        },
        [
          _c("div", { staticClass: "timeline-popup__header" }, [
            _c(
              "span",
              {
                staticClass: "timeline-popup__sensor",
                attrs: { title: _vm.sensorName },
              },
              [_vm._v(_vm._s(_vm.sensorName))]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "timeline-popup__time" }, [
              _vm._v(_vm._s(_vm.timeLabel)),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "timeline-popup__count" }, [
              _vm._v(_vm._s(_vm.$t("label.count", { count: _vm.count }))),
            ]),
          ]),
          _vm._v(" "),
          _vm.detailed
            ? [
                _c(
                  "div",
                  {
                    staticClass: "timeline-popup__thumbnail",
                    attrs: { "data-testid": "popup-thumbnail" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("show-gallery")
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "timeline-popup__thumbnail-img",
                      attrs: {
                        src: _vm.thumbnailUrl,
                        alt: _vm.sensorName,
                        "data-testid": "popup-thumbnail-img",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        staticClass: "timeline-popup__play-icon",
                        attrs: { dark: "", size: "36" },
                      },
                      [_vm._v("fa-play-circle")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "timeline-popup__link",
                    attrs: { to: _vm.activityLink },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("link.view_activity")) +
                        "\n    "
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }